<span class="link" [ngClass]="{'visited': visited}" tappable (click)="onClick($event)"><ng-content></ng-content></span>